export default {
  state: {
    gates: [],
    tempGateIds: [],
    gatesMeta: {},
    gateFormData: null,
    currentGate: {},
  },
  getters: {
    gates: state => state.gates,
    tempGateIds: state =>
      state.tempGateIds.length > 0
        ? state.tempGateIds
        : JSON.parse(localStorage.getItem('tempGateIds')),
    gatesMeta: state => state.gatesMeta,
    gateFormData: state =>
      state.gateFormData ?? JSON.parse(localStorage.getItem('gateFormData')),
    currentGate: state => state.currentGate,
    currentAddress: state => {
      return state.currentGate && state.currentGate.property
        ? state.currentGate.property.address
        : null
    },
    currentServer: state => {
      return state.currentGate && state.currentGate.sigur_server
        ? state.currentGate.sigur_server
        : null
    },
  },
  mutations: {
    SET_CURRENT_GATE(state, payload) {
      state.currentGate = payload
    },
    SET_GATES(state, payload) {
      state.gates = payload
    },
    ADD_NEW_GATE(state, payload) {
      state.gates.push(payload)
    },
    REMOVE_GATES(state, payload) {
      state.gates = state.gates.filter(gate => !payload.includes(gate.cuid))
    },
    SET_TEMP_GATE_IDS(state, payload) {
      state.tempGateIds.push(payload)
      localStorage.setItem('tempGateIds', JSON.stringify(payload))
    },
    DELETE_TEMP_GATE_IDS(state) {
      state.tempGateIds = []
      localStorage.removeItem('tempGateIds')
    },
    SET_GATES_META(state, payload) {
      state.gatesMeta = payload
    },
    SET_GATE_FORM_DATA(state, payload) {
      state.gateFormData = payload
      if (payload) {
        localStorage.setItem('gateFormData', JSON.stringify(payload))
      } else {
        localStorage.removeItem('gateFormData')
      }
    },
  },
  actions: {
    setCurrentGate({ commit }, payload) {
      commit('SET_CURRENT_GATE', payload)
    },
    setGates({ commit }, payload) {
      commit('SET_GATES', payload)
    },
    addNewGate({ commit }, payload) {
      commit('ADD_NEW_GATE', payload)
    },
    removeGates({ commit }, cuid) {
      commit('REMOVE_GATES', cuid)
    },
    setTempGateIds({ commit }, payload) {
      commit('SET_TEMP_GATE_IDS', payload)
    },
    deleteTempGateIds({ commit }) {
      commit('DELETE_TEMP_GATE_IDS')
    },
    setGatesMeta({ commit }, payload) {
      commit('SET_GATES_META', payload)
    },
    setGateFormData({ commit }, payload) {
      commit('SET_GATE_FORM_DATA', payload)
    },
  },
}
